import React from "react";
import WarningIcon from "@material-ui/icons/WarningTwoTone";
import { KYC_DETAIL_CONTEXT } from "../../PayoutDetails/constants";

export const KycWarningBanner = ({ bannerConfig }) => {
  if (
    !bannerConfig ||
    bannerConfig?.actionText !== KYC_DETAIL_CONTEXT.actionText
  ) {
    return null;
  }

  return (
    <div
      onClick={bannerConfig.onActionClick}
      className={`tw-w-full tw-flex tw-items-center tw-justify-center tw-py-[14px] pointer`}
      style={{
        backgroundColor: bannerConfig.backgroundColor,
        color: bannerConfig.textColor,
      }}
    >
      <WarningIcon className={`!tw-text-[24px] ${bannerConfig.iconClass}`} />

      <div className={`tw-ml-2 tw-text-[13px]`}>
        {bannerConfig.text}&nbsp;
        <u className={`tw-pointer`}>{bannerConfig.actionText}</u>
      </div>
    </div>
  );
};
